var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup-result" }, [
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("GlobalConfig.lastFiveRunsTime")))
    ]),
    _c(
      "ul",
      { staticClass: "popup-result-scroll" },
      [
        _vm.isShow
          ? _vm._l(_vm.resultList, function(item) {
              return _c("li", { key: item }, [_vm._v(_vm._s(item))])
            })
          : _c("li", [_vm._v(_vm._s(_vm.$t("GlobalConfig.tip5")))])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }